const { getElement, getElements } = window.BAO.Utils
const preBuyUtils = new window.PreBuyUtils()

export class ProductForm extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()

    await this.checkPreBuy()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  async checkPreBuy () {
    if (this.dataset.checkPreBuy === undefined) return

    const productId = this.dataset.productId
    const variantId = this.dataset.variantId

    if (!productId || !variantId) return

    const preBuyData = await preBuyUtils.getPreBuyData(productId, variantId)
    const legacyPreOrder = getElement(
      `[data-preorder="true"][data-variant-id="${variantId}"]`,
    )

    const urlParams = new URLSearchParams(window.location.search)
    const variantIsSelected = urlParams.get('variant') || false

    if (!legacyPreOrder && preBuyData?.enabled && preBuyData?.variantPool) {
      const sellingPlanId =
        preBuyData?.variantPool?.sellingPlanId?.replace(
          'gid://shopify/SellingPlan/',
          '',
        ) || ''

      // Add the data-pre-order attribute to the button
      const addToCartButton = this.querySelector('[data-product-add-to-cart]')
      if (addToCartButton) {
        addToCartButton.setAttribute('data-pre-order', 'true')
        addToCartButton.setAttribute('data-variant-id', variantId)
      }

      const buttonText = getElements(`[data-product-add-to-cart-text]`)

      buttonText.forEach(el => {
        // Help: Need to check if a variant is selected here. If it isn't, the innerText is different.
        if (variantIsSelected) {
          el.innerText = window.theme.strings.preOrder
        } else {
          el.querySelector('[data-product-add-to-cart-text-inner]').innerText =
            window.theme.strings.preOrder
        }
      })

      const estimatedDispatch = document.querySelectorAll(
        '[data-product-estimated-dispatch]',
      )

      if (preBuyData?.variantPool?.estDispatchDateFormatted) {
        estimatedDispatch.forEach(el => {
          el.innerHTML = `${window.theme.strings.estimatedDispatchPrefix} ${preBuyData?.variantPool?.estDispatchDateFormatted}`
        })
      } else {
        estimatedDispatch.forEach(el => {
          el.innerHTML = ''
        })
      }

      const propertiesEl = this.querySelector('[data-line-items]')
      if (propertiesEl) {
        const date = new Date(preBuyData?.variantPool?.zonedEstDispatchDate)
        const month = date.getMonth() + 1
        const dateFormatted = `${String(month).padStart(2, '0')}/${String(
          date.getDate(),
        ).padStart(2, '0')}/${date.getFullYear()}`

        propertiesEl.innerHTML = `
          <input type="hidden" name="properties[_preorder]" value="true">
          <input type="hidden" name="properties[${
            window.theme.strings.estimatedDispatchPrefix
          }]" value="${preBuyData?.variantPool?.estDispatchDateFormatted}">
          <input type="hidden" name="properties[_pool_location]" value="${
            preBuyData?.variantPool?.location
          }">
          <input type="hidden" name="properties[_locationId]" value="${
            preBuyData?.variantPool?.locationId
          }">
          <input type="hidden" name="properties[_dispatch_date]" value="${
            preBuyData.variantPool.zonedEstDispatchDate
          }">
          <input type="hidden" name="properties[_start_date]" value="${dateFormatted}">
          <input type="hidden" name="selling_plan" value="${
            sellingPlanId ? parseInt(sellingPlanId, 10) : null
          }">
        `
      }
    } else if (
      !legacyPreOrder &&
      preBuyData?.enabled &&
      !preBuyData?.variantPool &&
      preBuyData.currentlyNotInStock &&
      variantIsSelected
    ) {
      const buttonText = getElements(`[data-product-add-to-cart-text]`)
      buttonText.forEach(el => {
        el.innerText = window.theme.strings.soldOut
      })

      const addToCartButton = getElements(`[data-product-add-to-cart]`)
      addToCartButton.forEach(el => {
        el.disabled = true
      })
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
